import React from 'react'

import Localization from '~/client/src/shared/localization/LocalizationManager'
import type { ResourceSchema } from '~/client/src/shared/resources/domain/resourceSchema'

import PropertyActionDialog from './PropertyActionDialog'

interface IProps {
  isOpen: boolean
  onClose: () => void
  propertyId: string
  projectId: string
  onArchived: () => void
  resourceSchema: ResourceSchema
}

export default function ArchivePropertyDialog({
  isOpen,
  onClose,
  propertyId,
  projectId,
  onArchived,
  resourceSchema,
}: IProps) {
  const t = Localization.translator

  return (
    <PropertyActionDialog
      isOpen={isOpen}
      onClose={onClose}
      propertyId={propertyId}
      projectId={projectId}
      onComplete={onArchived}
      resourceSchema={resourceSchema}
      action="archive"
      title={t.archiveProperty}
      confirmationWord="Archive"
      getConfirmationText={t.archivePropertyConfirmation}
      errorFallback={t.failedToArchive}
    />
  )
}
